import cn from 'classnames';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PROMPT_TYPE, AI_LOADING_OPTIONS } from '../../constants/aiChatbot';
import { ChatTextInput } from './ChatTextInput';
import { CymbioSpinner } from '../common/Spinner';
import { IncomingMessage } from './IncomingMessage';
import { OutgoingMessage } from './OutgoingMessage';
import { PromptInfo } from './PromptInfo';
import { WidgetContent } from './WidgetContent';
import { WidgetHeader } from './WidgetHeader';
import styles from './AiChatbot.module.scss';
import { getChatHistory, sendUserPrompt } from '../../store/actions/aiChatbot';
import { scrollToFinalChatItem } from '../../utils/aiChatbot';
import { DateMessage } from '../../components/AiChatbot/DateMessage';
import { isEmpty } from 'lodash';

export function Widget() {
  const dispatch = useDispatch();
  const ref = useRef();
  const { history, ui } = useSelector((state) => state.aiChatbot);
  const isLoadingHistory = ui.loading[AI_LOADING_OPTIONS.HISTORY] || history === null;

  const sendPrompt = (userPrompt) => {
    dispatch(sendUserPrompt(userPrompt));
  };

  React.useEffect(() => {
    dispatch(getChatHistory());
  }, []); // eslint-disable-line

  React.useEffect(() => {
    if (!isEmpty(history)) {
      scrollToFinalChatItem();
    }
  }, [history, ui.loading]);

  React.useEffect(() => {
    if (!isEmpty(history)) {
      ref.current?.classList.add(styles.sticky);
    }
  }, [history]);

  const renderChatItem = (historyObjects, outerIndex) => {
    const [date, chatItems] = historyObjects;
    const prompts = [];
    prompts.push(
      <div
        ref={ref}
        key={`${outerIndex}`}
        className={cn(
          styles.messageContainer,
          styles.dateMessageContainer,
          'messageContainerAnchor',
          'dateMessageAnchor',
        )}
      >
        <DateMessage text={date} />
      </div>,
    );

    chatItems.forEach((chatItem, index) => {
      if (chatItem.promptType === PROMPT_TYPE.AI) {
        prompts.push(
          <div key={`${outerIndex}:${index}`} className={cn(styles.messageContainer, 'messageContainerAnchor')}>
            <IncomingMessage text={chatItem.content} />
          </div>,
        );
      } else if (chatItem.promptType === PROMPT_TYPE.HUMAN) {
        prompts.push(
          <div
            key={`${outerIndex}:${index}`}
            className={cn(styles.messageContainer, styles.outgoingMessageContainer, 'messageContainerAnchor')}
          >
            <OutgoingMessage text={chatItem.content} />
          </div>,
        );
      } else {
        throw new Error(`[aiChatboy][Widget] unknown prompt type '${chatItem.promptType}'`);
      }
    });

    return prompts;
  };

  return (
    <>
      <WidgetHeader />
      <WidgetContent>
        <div className={styles.messagesAreaContainer}>
          {isLoadingHistory ? <CymbioSpinner /> : <>{Object.entries(history).map(renderChatItem)}</>}
        </div>

        <div className={styles.bottomArea}>
          <ChatTextInput onSubmit={sendPrompt} />
          <PromptInfo />
        </div>
      </WidgetContent>
    </>
  );
}
